if (!customElements.get('atos-info')) {
  customElements.define('atos-info', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const stories = [...this.querySelectorAll('.atos-story')];
      if (stories.length < 2) return;
      const sequence = this.querySelector('.atos-scroll');
      if (!sequence) return;
      const stage = sequence.querySelector('.atos-scroll-stage');
      const steps = [...sequence.querySelectorAll('button')];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let active = -1;
      let enabled = false;
      let travel = 0;
      let top = 0;
      const activate = (index) => {
        if (index === active) return;
        active = index;
        sequence.dataset.chapter = String(index + 1);
        stories.forEach((story, i) => {
          story.classList.toggle('is-active', i === index);
          story.setAttribute('aria-hidden', String(i !== index));
          story.inert = i !== index;
        });
        steps.forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
      };
      const update = () => {
        this.scrollFrame = null;
        if (!enabled) return;
        const progress = Math.max(0, Math.min(1, (top - sequence.getBoundingClientRect().top) / travel));
        activate(Math.min(stories.length - 1, Math.floor(progress * stories.length)));
      };
      const request = () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(update);
      };
      const layout = () => {
        sequence.classList.add('is-enhanced');
        const height = Math.ceil(stage.getBoundingClientRect().height);
        // A tall panel scrolls fully into view before pinning; it never disables the sequence.
        top = Math.min(innerWidth < 750 ? 76 : 100, innerHeight - height - 20);
        sequence.style.setProperty('--atos-scroll-top', `${top}px`);
        enabled = !reducedMotion.matches;
        sequence.classList.toggle('is-enhanced', enabled);
        if (enabled) {
          travel = Math.round(innerHeight * .8 * stories.length);
          sequence.style.height = `${height + travel}px`;
          // Keep upcoming photographs ready before their scroll transition.
          stories.forEach(story => { story.querySelector('img').loading = 'eager'; });
          active = -1;
          update();
        } else {
          sequence.style.removeProperty('height');
          stories.forEach(story => {
            story.removeAttribute('aria-hidden');
            story.inert = false;
          });
        }
      };
      steps.forEach((button, index) => button.addEventListener('click', () => {
        if (!enabled) return;
        const start = scrollY + sequence.getBoundingClientRect().top - top;
        window.scrollTo({ top: start + travel * (index + .5) / stories.length, behavior: 'smooth' });
      }, { signal }));
      window.addEventListener('scroll', request, { passive: true, signal });
      window.addEventListener('resize', layout, { passive: true, signal });
      window.addEventListener('pageshow', layout, { signal });
      window.addEventListener('load', layout, { signal });
      this.stageObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(layout);
      });
      this.stageObserver.observe(stage);
      reducedMotion.addEventListener('change', layout, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = stories.findIndex(story => story === event.target || story.contains(event.target));
        if (enabled && index >= 0) steps[index].click();
      }, { signal });
      layout();
      document.fonts.ready.then(() => { if (!signal.aborted) layout(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.stageObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }
  });
}
